/**
 * Partner Administrator related types
 * These aliases reference the auto-generated API models to keep types in sync with backend responses
 */

import {
  PartnerAdministratorResponse,
  PartnerResponse,
  UpdatePartnerRequest as GeneratedUpdatePartnerRequest,
} from '@generated/models'

export type PartnerAdministrator = PartnerAdministratorResponse

export type Partner = PartnerResponse

export type UpdatePartnerRequest = GeneratedUpdatePartnerRequest

export type {
  EmailTemplateResponse,
  UpdateEmailTemplateRequest,
} from '@generated/models'
export {EmailType} from '@generated/models'
